import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Hide, Show, useColorMode } from '@chakra-ui/react';
import { CookieIcon } from '@bnb-chain/icons';
import { useEffect, useRef } from 'react';
import { Typography } from '../../../Typography';
import { theme } from '../../../../modules';
import { Base } from './Base';
import { Medium } from './Medium';
export const Language = ({ localeSwitchable = true, extraActions = [], }) => {
    const ref = useRef(null);
    const { colorMode } = useColorMode();
    useEffect(() => {
        const handler = () => {
            const element = document.querySelector('.ot-sdk-show-settings');
            if (!element)
                return;
            element.click();
        };
        ref.current?.addEventListener('click', handler);
        return () => {
            ref.current?.removeEventListener('click', handler);
        };
    }, []);
    return (_jsxs(Flex, { className: localeSwitchable ? 'locale-switch-container locale-switchable' : 'locale-switch-container', alignItems: "center", gap: theme.sizes['4'], children: [extraActions.map((action, index) => (_jsxs(Flex, { userSelect: 'none', cursor: 'pointer', alignItems: "center", gap: theme.sizes[1], color: theme.colors[colorMode].text.tertiary, transition: 'all .15s', sx: {
                    '@media (hover:hover)': {
                        _hover: {
                            color: theme.colors[colorMode].text.primary,
                        },
                    },
                }, onClick: action.onClick, children: [action.icon, _jsx(Typography, { display: { base: 'none', md: 'inline' }, as: "span", variant: "label", size: "md", fontWeight: "500", children: action.text })] }, index))), _jsxs(Flex, { userSelect: 'none', cursor: 'pointer', ref: ref, alignItems: "center", gap: theme.sizes[1], color: theme.colors[colorMode].text.tertiary, transition: 'all .15s', sx: {
                    '@media (hover:hover)': {
                        _hover: {
                            color: theme.colors[colorMode].text.primary,
                        },
                    },
                }, children: [_jsx(CookieIcon, { boxSize: theme.sizes['5'] }), _jsx(Typography, { display: { base: extraActions.length ? 'none' : 'inline', md: 'inline' }, as: "span", variant: "label", size: "md", fontWeight: "500", children: "Cookies" })] }), _jsx(Flex, { display: 'none', className: "ot-sdk-show-settings", children: "Cookie Preferences" }), localeSwitchable && (_jsxs(_Fragment, { children: [_jsx(Show, { below: "md", children: _jsx(Base, {}) }), _jsx(Hide, { below: "md", children: _jsx(Medium, {}) })] }))] }));
};
